// 计算相除，并将结果转换为两位百分比，比如35%这样
export function calculatePercentage(dividend?: number, divisor?: number): string {
    const result = (dividend ?? 0) / (divisor ? (divisor === 0 ?1 : divisor) :1);
    return `${(result * 100).toFixed(0)}%`;
}

// 将小数转换为百分数
export function decimalToPercentage(decimal: number): string {
    return `${(decimal * 100).toFixed(0)}%`;
}

// 将小数转换为百分数
export function decimalToPercentage1(decimal: number): string {
    return `${(decimal * 100).toFixed(1)}%`;
}